import { render, staticRenderFns } from "./ProdutosVendidosPorFornecedor.vue?vue&type=template&id=4f51847e&scoped=true&"
import script from "./ProdutosVendidosPorFornecedor.vue?vue&type=script&lang=js&"
export * from "./ProdutosVendidosPorFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f51847e",
  null
  
)

export default component.exports